import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import * as VueCookie from './utils/cookie'

import './common/styles/index.less'

Vue.prototype.$ck = VueCookie

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: VueCookie.getCookie('language') || 'zh',
  messages: {
    zh: require('./common/i18n/zh-CN'),
    en: require('./common/i18n/en-US')
  }
})
new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js